// @core/api/endpoints/workflow/delete_node_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/workflow';

/**
 * Delete node type
 * Deletes a custom node type. Built-in node types cannot be deleted. Pipelines using this node type will show it as unknown.
 */
export async function DeleteNodeType(
  node_type_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/node-types/:node_type_id`;
  requestPath = requestPath.replace(':node_type_id', encodeURIComponent(node_type_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
